import { createModel } from "hox";
import { useState } from "react"
import { IFriendshipDetail, IFriendshipSearch, IFriendshipField } from "./friendshipTypes"
import { friendshipService } from "./friendshipService";
import { message } from "antd";
import { TablePaginationConfig } from "antd/lib/table";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "@/utils/constants";
import { ISearchPage } from "@/types/AppTypes";
import useGlobalModel, { transPgToPagination } from "@/model/globalModel";
import { useLockFn } from "ahooks";
import { globalPrompt } from "@/components/message";
interface IRestaurantType {
    visible: boolean,
    mode: "add" | "edit" | "look"
}
export const useFriendshipModel = createModel(function () {
    const { user } = useGlobalModel()

    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //列表数据
    const [dataSource, setDataSource] = useState<IFriendshipDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IFriendshipField>({});
    //分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //表格选中的值
    const [selectedRow, setSelectedRow] = useState<IFriendshipField[]>([]);
    //抽屉框
    const initShopDrawer: IRestaurantType = { visible: false, mode: "add" }
    const [visibleDrawer, setVisibleDrawer] = useState<IRestaurantType>(initShopDrawer);
    const setIVisibleDrawer = (str?: "add" | "edit" | "look") => setVisibleDrawer(str ? { visible: true, mode: str } : initShopDrawer);


    //设置搜索value
    const updateSearchParam = (updateParam: IFriendshipField) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    //列表查询
    const loadData = async (page?: ISearchPage, searchValue: IFriendshipField = searchParam) => {
        const searchParams = {
            ...searchValue,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await friendshipService.page(searchParams);
        const { items, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(items);
    }
    //新增友情链接
    const insertDetail = useLockFn(async (params: IFriendshipField) => {
        let { retData } = await friendshipService.insert({ ...params, createUser: user.userName });
        if (retData) {
            loadData();
            setIVisibleDrawer();
            globalPrompt("message", { text: "友情链接新增成功", type: "success" })
        } else {
            globalPrompt("message", { text: "友情链接新增失败", type: "success" })
        }
    })
    //编辑友情链接
    const editDetail = useLockFn(async (params: IFriendshipField) => {
        let { retData } = await friendshipService.update({ ...params, id: selectedRow[0].id, updateUser: user.userName })
        if (retData) {
            loadData();
            setIVisibleDrawer();
            globalPrompt("message", { text: "友情链接编辑成功", type: "success" })
        } else {
            globalPrompt("message", { text: "友情链接编辑失败", type: "success" })
        }
    })
    const onRemove = useLockFn(async (id:string)=>{
        let { retData } = await friendshipService.delete(id)
        if (retData) {
            loadData();
            globalPrompt("message", { text: "友情链接删除成功", type: "success" })
        }
    })
    return {
        dataSource,
        searchParam,
        pgCfg,
        selectedRowKeys,
        initPgCfg,
        selectedRow,
        visibleDrawer,
        setSelectedRowKeys,
        setPgCfg,
        setSearchParam,
        setDataSource,
        updateSearchParam,
        resetSearchParam,
        loadData,
        setSelectedRow,
        setVisibleDrawer,
        setIVisibleDrawer,
        insertDetail,
        editDetail,
        onRemove
    }
})